export function isNumber(data: any) {
  return !isNaN(data);
}
